import React from 'react';
import GridProductLookup from './index';
import { LookupRow } from './types';

export interface PreventiveSubgroupLookupHandlers {
  PegarValorGrid: (row: LookupRow) => void;
  Iconeadd: () => void;
  Iconeditar: (row: LookupRow) => void;
  iconeExcluir?: (row: LookupRow) => void;
}

export function renderPreventiveSubgroupLookupGrid(
  handlers: PreventiveSubgroupLookupHandlers,
): React.ReactElement {
  return (
    <GridProductLookup
      endPoint="preventivesubgroup/buscarpreventivesubgroup"
      params="%"
      listTitle="Subgrupos preventiva"
      listSubtitle="Selecione um subgrupo ou cadastre um novo."
      newButtonLabel="Novo subgrupo"
      searchPlaceholder="Pesquisar subgrupos..."
      PegarValorGrid={handlers.PegarValorGrid}
      Iconeadd={handlers.Iconeadd}
      Iconeditar={handlers.Iconeditar}
      onDelete={handlers.iconeExcluir}
    />
  );
}
